
document.addEventListener("DOMContentLoaded", function() {





    if ( document.querySelector('.easter-popup-wrap') && Cookies.get('easter-cookie-dismiss') != 'true' ) {




        document.querySelector('body').classList.add('with-easter-popup');
        document.querySelector('.easter-popup-wrap').classList.add('active');
    }



    document.querySelector('.easter-popup-wrap').addEventListener('click', function(event) {
        document.querySelector('body').classList.remove('with-easter-popup');
        document.querySelector('.easter-popup-wrap').classList.remove('active');

        Cookies.set('easter-cookie-dismiss', 'true', { expires: 1, path: '/' });
    });


});

